import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (    
    <>
    <div className="container-fluid bg-dark footer mt-5 py-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-5">
            <div className="row g-5">
                <div className="col-lg-6 col-md-6">
                    <h4 className="text-primary mb-4">Our Office</h4>
                    <p className="mb-2"><i className="fa fa-map-marker-alt text-primary me-3"></i>1/8, Mahatma Phule C.H.S. Ltd.<br/> Pant Nagar, Ghatkopar(E), Mumbai-400075</p>
                    {/* <p className="mb-2"><i className="fa fa-phone-alt text-primary me-3"></i>+012 345 67890</p> */}
                    <p className="mb-2"><i className="fa fa-envelope text-primary me-3"></i>marketing@gloryoverseas.in</p>
                  
                </div>
                <div className="col-lg-6 col-md-6">
                    <h4 className="text-primary mb-4">Quick Links</h4>
                    <Link className="btn btn-link" to="/about-us">About Us</Link>
                    <Link className="btn btn-link" to="/contact-us">Contact Us</Link>
                    <Link className="btn btn-link" to="/services">Our Services</Link>                    
                    <Link className="btn btn-link" to="/brands">Brands</Link>
                </div>
               
            </div>
        </div>
    </div>  
    
    <div className="container-fluid copyright py-4">
        <div className="container">
            <div className="row">
                <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                    &copy; <a className="fw-medium" href="#">GloryOverseas</a>, All Right Reserved.
                </div>
             
            </div>
        </div>
    </div>
    <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up"></i></a>
    </>
  )
}
